import 'core-js';
import { renderPage } from '@qxwz/ccms-render';
import 'whatwg-fetch';
import 'regenerator-runtime';
import mobile from 'is-mobile';
import { getElement, getParamsData, setupWebViewJavascriptBridge } from './utils';

const channelMap = {
    lp: 'SEM',
    hyal: 'HYAL',
    solution: 'DEVELOPER_SOLUTION',
    products: 'PRODUCT',
    goodsdetail: 'goodsdetail',
    market: 'market',
    campaign: 'campaign',
    commodity: 'goodsdetail',
    solutions: 'solutions',
    'en-solution': 'en-solution',
    'en-product': 'en-product',
    'ru-solution': 'ru-solution',
    'ru-product': 'ru-product',
};

// 使用不符合规范的 URL，使用一个映射关系

const urlList = [
    {
        url: /^(http:\/\/|https:\/\/)(hd).*(.qxwz.com\/urb)$/,
        channelType: 'campiagn',
        pageCode: 'xr',
    },
];

function toNotFound() {
    window.location.href = '//www.qxwz.com/404';
}

const inApp = navigator.userAgent.indexOf('qxwz') > -1;

if (inApp) {
    setupWebViewJavascriptBridge();
}

(async function () {
    const isMobile = mobile();

    if (/msie|trident/i.test(window.navigator.userAgent)) {
        // ie 浏览器
        getElement('#root').innerHTML =
            '<p style="text-align: center; margin: 60px">温馨提示：您当前的浏览器版本过低，可能存在安全风险，建议升级浏览器，<a href="//hd.qxwz.com/updater">下载 &gt;</a></p>';
        return false;
    }

    if (!isMobile) {
        getElement('#root').style.minWidth = '1200px';
    }

    // TODO channelType;
    const { pathname, origin } = window.location;

    let [_, channel, pageCode = ''] = (pathname !== '/' && pathname.match(/^\/(.*)\/(.*)/)) || [];

    let channelType = channelMap[channel];

    const version = getParamsData('version') || '';
    const omit = getParamsData('omit') || '';

    let platform = getParamsData('dt') || '';

    const url = `${origin}${pathname}`;

    const item = urlList.find((item) => item.url.test(url));
    if (item) {
        channelType = item.channelType;
        pageCode = item.pageCode;
    }

    if (!pageCode) {
        console.error('no pageCode');
        toNotFound();
        return false;
    }

    if (!channelType) {
        console.error('no channelType');
        toNotFound();
        return false;
    }

    if (!platform) {
        platform = isMobile ? 'M' : 'PC';
    }

    try {
        const res = await fetch(
            `/bffportal/proxy/ccmsservice/api/page/detail?pageCode=${pageCode}&channelType=${channelType}&version=${version}&platform=${platform.toLocaleUpperCase()}`,
        ).then((res) => res.json());

        if (+res.code !== 200) {
            console.error(res.message || res.code);
            toNotFound();
            return false;
        }

        const { data } = res;
        getElement('meta[name=keywords]')?.setAttribute('content', data.pageKeywords);
        getElement('meta[name=description]')?.setAttribute('content', data.pageDescription);
        getElement('meta[name=version]')?.setAttribute('content', data.version);
        getElement('meta[name=spm-site]')?.setAttribute('content', channelType);
        getElement('body')?.setAttribute('data-spm-page', pageCode);
        document.title = data.pageTitle;

        if (data.jsonLd) {
            const script = document.createElement('script');
            script.type = 'application/ld+json';
            script.textContent = data.jsonLd;
            document.head.appendChild(script);
        }

        renderPage({
            ...data,
            omit,
            theme: data && data.theme ? data.theme : {},
            el: '#root',
        });
    } catch (error) {
        console.error(error);
        toNotFound();
    }
})();
